import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "bin",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "project-group-bin" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
